<template>
  <div>
    <div class="mb-10 pa-3">
      <info-box :label="$t('rentals.allRentals')" :value="allRentals"></info-box>
    </div>
    <div class="page-body">
      <rentals-table :data="data"></rentals-table>
    </div>
  </div>
</template>

<script>
import { RENTALS } from '@/libs/fakeData'
import InfoBox from '@/components/Share/InfoBox'
import RentalsTable from '@/components/Tables/Rentals'

export default {
  components: { InfoBox, RentalsTable },
  data () {
    return {
      allRentals: 285,
      data: RENTALS
    }
  }
}
</script>
